import { jsx as _jsx } from "react/jsx-runtime";
import { SpinLoaderContainer } from "./style";
export const SpinLoader = (_props) => {
    const { logo, logoWidth } = _props;
    return (_jsx(SpinLoaderContainer, { children: _jsx("div", Object.assign({ style: {
                animation: "rotation 1.5s infinite ",
                transformOrigin: "center",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }, className: "image-outer-wrapper" }, { children: _jsx("div", Object.assign({ className: "image-inner-wrapper", style: { animation: "rotation 1.5s infinite " } }, { children: _jsx("img", { src: logo, alt: "logo", width: logoWidth, height: "auto" }) })) })) }));
};
